<div class="reward-card-container kh-small-text-primary" [ngClass]="!!rarity ? 'reward-card-' + rarity : ''" [class.hidden-bg]="hiddenBg">
  <div class="reward-card-bg"></div>
  <div class="reward-card-content">
    <kh-img class="reward-icon" *ngFor="let icon of icons" [path]="icon"></kh-img>
    <div class="rewards-count-text" *ngIf="count">×{{count}}</div>
  </div>
</div>
